<div class="admin-content">
  <cei-admin-page-cabecalho titulo="Detalhes da Permissão" [rotaVoltar]="'/admin/permissoes'" />
  @if (permissao(); as permissao) {
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <table class="admin-detail-table">
        <tbody>
          <tr>
            <th scope="row">ID</th>
            <td>{{ permissao.id }}</td>
          </tr>
          <tr>
            <th scope="row">Nome</th>
            <td>{{ permissao.name }}</td>
          </tr>
          <tr>
            <th scope="row">Codename</th>
            <td>{{ permissao.codename }}</td>
          </tr>
        </tbody>
      </table>
    </cei-panel>
    <div class="admin-content__actions" [routerLink]="['/admin/permissoes/atualizar', permissao.id]">
      <cei-button type="button">Editar</cei-button>
    </div>
  }
</div>
